import { SpotTruckInspectionSettingsModel } from "src/app/api/api-types";
import { getApiDetailsDecorator } from "src/utils";

const api = getApiDetailsDecorator<SpotTruckInspectionSettingsModel>();

export class SpotTruckInspectionSettings {
  private constructor(args: ClassProperties<SpotTruckInspectionSettings>) {
    this.isAdHoc = args.isAdHoc;
    this.isAtLogIn = args.isAtLogIn;
    this.isExpired = args.isExpired;
  }

  @api() public readonly isAdHoc: boolean;
  @api() public readonly isAtLogIn: boolean;
  @api({ key: "isOnce" }) public readonly isExpired: boolean;

  public static deserialize(
    data: SpotTruckInspectionSettingsModel,
  ): SpotTruckInspectionSettings {
    return new SpotTruckInspectionSettings({ ...data, isExpired: data.isOnce });
  }

  public static serialize(
    data: SpotTruckInspectionSettings,
  ): SpotTruckInspectionSettingsModel {
    return { ...data, isOnce: data.isExpired };
  }
}
